export default __webpack_public_path__ + "static/media/logo-tzuchi.f35827b1.png";